export default __webpack_public_path__ + "static/media/linkedin.cab7a443.svg";